export enum DatesFilterOptions {
    All = 1,
    ThisMonth = 2,
    LastMonth = 3,
    Last12Month = 4,
    Custom = 5
}
